import React from 'react'

export const Container = ({ children, className = '' }) => {
  return <div className={`mx-24 md:mx-64 ${className}`}>{children}</div>
}
